<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{'--width': widthVar}"  class="pageHeader">{{$store.state.themeTitle}}日志汇总</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1"></OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择组织结构" style="width:320px;" @focus="dialogOpen1" @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室名称`">
          <el-select v-model="formInline.training_room" clearable filterable :placeholder="`请选择${$store.state.themeTitle}室名称`">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.training_name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="实训项目">
          <el-input v-model="formInline.train_name" clearable placeholder="请输入实训项目"></el-input>
        </el-form-item>
        <el-form-item label="创建人">
          <el-input v-model="formInline.teacher" clearable placeholder="请输入创建人"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
        <el-form-item>
          <!-- <el-button type="primary" @click="handleAdd()">新建</el-button> -->
        </el-form-item>
        <!-- <el-form-item>
          <el-button type="primary" @click="handleExport">{{exportTitle}}</el-button>
        </el-form-item> -->
        <!-- <el-form-item>
          <el-button type="primary" @click="handlePrint">打印</el-button>
        </el-form-item> -->
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" ref="table" border style="width: 100%">
        <custom-table-column fixed prop="train_name" label="实训项目" width="160">
        </custom-table-column>
        <custom-table-column prop="room_name" :label="`${$store.state.themeTitle}室名称`" width="160">
        </custom-table-column>
        <custom-table-column prop="structure_1" label="院系" width="160">
        </custom-table-column>
        <custom-table-column prop="major" label="专业" width="160">
        </custom-table-column>
        <custom-table-column prop="class" label="班级" width="180">
        </custom-table-column>
        <custom-table-column prop="people_num" label="人数" width="120">
        </custom-table-column>
        <custom-table-column prop="date" label="实训时间" width="120">
          <template slot-scope="scope">
            <span>{{scope.row.date? $until.getDateStr(new Date(scope.row.date).getTime() / 1000,'-'):''}}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="zc" label="周次" width="120">
        </custom-table-column>
        <custom-table-column prop="week" label="星期" width="120">
        </custom-table-column>
        <custom-table-column prop="sector" label="节次" width="120">
        </custom-table-column>
        <custom-table-column prop="device_use" label="设备使用情况记录" min-width="220">
        </custom-table-column>
        <custom-table-column prop="creator_name" label="创建人" width="160">
        </custom-table-column>
        <custom-table-column prop="created_at" label="创建时间" width="180">
        </custom-table-column>
        <!-- <custom-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button @click="handleEdit(scope.row)" type="text" size="small">编辑</el-button>
            <el-button @click="handleDelet(scope.row.id)" type="text" size="small">删除</el-button>
          </template>
        </custom-table-column> -->
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>

    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="746px">
      <OrganDialog ref="organDia" @getSelect="getSelect" :level="levell1" @handleOrganQuery="handleOrganQuery"></OrganDialog>
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="实训项目" prop="train_name">
          <el-input v-model="ruleForm.train_name" placeholder="请输入实训项目" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item :label="`${$store.state.themeTitle}室`" prop="room_id">
          <el-select v-model="ruleForm.room_id" style="width:216px;" :placeholder="`请选择${$store.state.themeTitle}室`" @change="handleClassChange">
            <el-option v-for="item in $store.state.trainRooms" :key="item.id" :label="item.training_name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="组织结构" prop="class">
          <el-input v-model="selectName" placeholder="请选择院系+专业+班级" style="width:552px;" @focus="dialogOpen" @clear="handeleClear" clearable></el-input>
        </el-form-item>
        <el-form-item label="人  数" prop="people_num">
          <el-input v-model.number="ruleForm.people_num" placeholder="请输入人数" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="实训时间" prop="date">
          <el-date-picker type="date" placeholder="选择开始时间" value-format="yyyy-MM-dd" v-model="ruleForm.date" style="width:216px;"></el-date-picker>
        </el-form-item>
        <el-form-item label="周  次" prop="zc">
          <el-input v-model="ruleForm.zc" placeholder="请输入周次" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="星  期" prop="week">
          <el-select v-model="ruleForm.week" clearable placeholder="请选择星期" style="width:216px;">
            <el-option v-for="item in $store.state.weeks" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="节  次" prop="sector">
          <el-input v-model="ruleForm.sector" placeholder="请输入节次" style="width:216px;"></el-input>
        </el-form-item>
        <el-form-item label="设备使用情况" prop="device_use">
          <el-input type="textarea" v-model="ruleForm.device_use" :rows="6" style="width:552px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;margin-bottom:0px;">
          <el-button type="primary" v-if="type=='add'" @click="submitFormByFun('ruleForm',createMethod)">确认</el-button>
          <el-button type="primary" v-if="type=='edit'" @click="submitFormByFun('ruleForm',updateMethod)">编辑</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
        <p style="padding:0px 26px 36px;font-size: 12px;color:#ed9f71;line-height: 1.5;">填写要求和说明：<br />
          1. 本记录本由{{ $store.state.themeTitle }}室管理员或在该室投课的教师填写;<br />
          2. 实训结束时，要及时、如实填写表格中的内容;<br />
          3.“第_周”:按校历实际周次填写;<br />
          4.“实训项目”:填写具体项目名称，不要填写课程名称;<br />
          5.“设备使用情况记录”:设备无损坏、无故障填“正常”;出现故障及损坏，要详细填写出现故障的“设备名称、故障部位、故障程度”并及时上报院系和教务处。知情不报者按教学事故处理。</p>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteMethod">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';

export default {
  name: 'trainingRoom',
  mixins: [mixinList, mixinOrgan],
  data() {
    return {
      classRooms: [],
      institutes: [
        { isid: '1', ismc: '机电学院' },
        { isid: '2', ismc: '土木学院' },
      ],
      formInline: {
        structure_1: '',
        major: '',
        training_room: '',
        train_name: '',
        teacher: '',
      },
      levell: [1, 2],
      levell1: [1, 2, 3],
      selectName: '',
      organLabel: '',
      ruleForm: {
        train_name: '',
        room_id: '',
        room_name: '',
        structure_1: '',
        major: '',
        class: '',
        people_num: 0,
        device_use: '',
        date: '',
        zc: '',
        week: '',
        sector: '',
      },
      rules: {
        train_name: [{ required: true, message: '请输入实训项目', trigger: 'blur' }],
        people_num: [
          { required: true, message: '面积不能为空' },
          { type: 'number', message: '面积必须为数字值' },
        ],
        class: [{ required: true, message: '请选择院系+专业+班级' }],
        date: [{ required: true, message: '请输入实习时间', trigger: 'blur' }],
        zc: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        week: [{ required: true, message: '请输入星期', trigger: 'change' }],
        sector: [{ required: true, message: '请输入节次', trigger: 'blur' }],
        room_id: [{ required: true, message: `请选择${this.$store.state.themeTitle}室`, trigger: 'change' }],
        device_use: [{ required: true, message: '请输入设备使用情况', trigger: 'blur' }],
      },
      type: 'add',
      title: '新增',
      tableName: '实训日志',
    };
  },
  created() {},
  mounted() {
    // this.getList();
    this.$store.dispatch('getTarinMent');
  },
  methods: {
    onSubmit() {
      console.log('submit!');
    },
    handleEdit(row, filterArr = ['updated_at', 'deleted_at', 'created_at']) {
      if (row.structure_1 && row.major && row.class) {
        this.selectName = `${row.structure_1}-${row.major}-${row.class}`;
      }
      this.type = 'edit';
      this.title = '编辑';
      this.ruleForm = this.$until.delProp(row, filterArr);
      console.log(this.ruleForm);
      this.centerDialogVisible = true;
    },
    handleInstituteChange(e) {
      console.log(e);
      this.ruleForm.institute_name = this.$until.getLabelName(this.institutes, 'isid', 'ismc', e);
    },
    async getTarinMent() {
      let res = await this.$api.instance.getTarinMent();
      if (res.code == 0) {
        this.classRooms = res.data;
      }
    },
    handleClassChange(e) {
      // this.ruleForm.room_id = e.id
      this.ruleForm.room_name = this.$until.getLabelName(this.$store.state.trainRooms, 'id', 'training_name', e);
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    handleBack() {
      this.$message.info('撤销中。。。');
    },
    handlePrint() {
      this.$message.info('打印中。。。');
    },
    async deleteMethod() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createMethod() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      let res = await this.$api.creat.creatLogAdd(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    async updateMethod() {
      let params = this.$until.easyDeepCopy(this.ruleForm);;
      let res = await this.$api.update.updateMethod(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '编辑成功！',
        });
        this.clearState();
      }
    },
    getOrganList() {
      this.tableData1 = [];
      if (this.selectNode.level == 3) {
        this.selectName = this.selectNode.structure_names || this.selectNode.name;
        let strArr = this.selectNode.structure_names.split('-');
        this.ruleForm.structure_1 = strArr[0];
        this.ruleForm.major = strArr[1];
        this.ruleForm.class = strArr[2];
      }
      if (!this.selectName) {
        this.ruleForm.structure_1 = '';
        this.ruleForm.major = '';
        this.ruleForm.class = '';
      }
    },
    handleQuery() {
      this.beforeQuery();
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.query.getLogAll(params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}
</style>
